import { Appointment } from '@dreryk/egabinet-appointment-frontend-api';

import { ButtonVariant } from '@dreryk/react-components';

import { useCurrentPractitionerConfidentialityMode } from '~libs.shared.account';
import { VisitEnterButton } from '~libs.desktop.shared.visit-enter';

import { useVisitStartCommand } from '../../../../../appointment/table/cells/useVisitStartCommand';
import { useVisitDependenciesContext } from '../../../../../dependencies';
import { appointmentsTranslationKeys, calendarTranslationKeys } from '../../../../../translations';

type AppointmentVisitStartVisitButtonProps = {
   readonly appointmentId: Appointment['id'];
   readonly disabled: boolean;
   readonly patientId: number;
   readonly onVisitAlreadyStartedFault: VoidFunction;
   readonly onAppointmentAlreadyCancelledFault: VoidFunction;
};

export const AppointmentVisitStartVisitButton = (props: AppointmentVisitStartVisitButtonProps): JSX.Element => {
   const { accountConfigurationVerificationEventInterceptor } = useVisitDependenciesContext();
   const { executeAsync: startVisit } = useVisitStartCommand({
      confidentialityLevel: useCurrentPractitionerConfidentialityMode(),
      onVisitAlreadyStartedFault: props.onVisitAlreadyStartedFault,
      onAppointmentAlreadyCancelledFault: props.onAppointmentAlreadyCancelledFault,
   });

   const handleStartVisit = async (): Promise<void> => {
      await startVisit({
         appointmentId: props.appointmentId,
      });
   };

   return (
      <VisitEnterButton
         compact
         appointmentId={props.appointmentId}
         label={appointmentsTranslationKeys.start}
         accountConfigurationVerificationEventInterceptor={accountConfigurationVerificationEventInterceptor}
         patientId={props.patientId}
         testId={'startVisit'}
         onClick={handleStartVisit}
         disabled={props.disabled}
         variant={ButtonVariant.PRIMARY}
         goBackButtonLabel={calendarTranslationKeys.goBackToCalendar}
      />
   );
};
